
export const ROUTES = {
  CALENDAR: '/tabs/calendar',
  BOOKING: '/tabs/client-dashboard',
  MAIN_DASHBOARD: '/tabs/dashboard'
} as const;

export function getDashboardRoute(_role: string): string {
  return ROUTES.MAIN_DASHBOARD;
}
